import { render, staticRenderFns } from "./PreviewTableCard.vue?vue&type=template&id=6b31b04b&scoped=true&"
import script from "./PreviewTableCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewTableCard.vue?vue&type=style&index=0&id=6b31b04b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31b04b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VImg,VProgressCircular})
